"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    fill: "transparent"
  }, props), /*#__PURE__*/React.createElement("circle", {
    className: "circle_svg__outer",
    transform: "rotate(-90 11 11)",
    cx: 10,
    cy: 12,
    r: 11
  }));
}

var MemoSvgCircle = /*#__PURE__*/React.memo(SvgCircle);
var _default = MemoSvgCircle;
exports["default"] = _default;